export default {
    CREATED: "Добавлен",
    CREATED_DATE_UNKNOWN: "Дата неизвестна",
    NAME: "Название",
    DESCRIPTION: "Описание",
    COORDS: "Координаты",
    COLOR: "Цвет",
    DIFFERENT_VALUES: "[разные значения]"
};
